var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHangingVine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 551,
    viewBox: "0 0 102 551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6187_11629)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6187_11629)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.435 14.8481C9.19786 31.8143 8.60963 61.7495 14.7973 80.3056C24.4011 109.116 28.3377 115.192 39.6836 153.69C45.4414 173.245 50.1585 190.075 45.0794 214.105C39.8307 238.975 30.0345 246.777 15.9737 275.679C4.28846 299.686 -3.27924 323.33 1.41522 350.221C2.81791 358.25 5.62327 383.768 25.4418 402.279C46.6405 422.072 71.1874 419.608 84.0039 432.157C96.8204 444.706 96.8543 479.66 85.9609 487.326C80.5651 491.13 74.1851 490.119 49.5816 487.076C35.7923 485.372 31.6182 490.301 29.616 493.753C26.8785 498.5 28.1567 505.961 32.2743 509.788C39.7175 516.693 53.1562 508.38 53.1222 508.005C53.043 506.915 51.9797 507.88 50.9051 507.824C44.5025 507.506 47.4323 512.571 39.1859 510.788C37.1384 510.345 32.8625 507.88 32.1272 502.293C31.6634 498.739 33.6996 492.788 37.6474 491.573C49.0952 488.064 68.269 494.185 74.6263 494.344C81.9904 494.525 84.8862 494.809 90.6893 490.778C100.338 484.066 102.114 468.894 101.979 457.777C101.854 447.715 102.307 427.728 81.2098 416.235C71.9453 411.193 51.2784 405.731 41.4709 396.373C37.0253 392.137 34.2652 391.013 23.8129 372.9C14.2882 356.399 16.0416 339.274 16.1208 330.155C16.2791 310.463 20.8039 296.177 29.2087 278.166C41.6066 251.626 46.7536 251.229 53.7444 233.013C63.7668 206.917 63.122 184.363 60.4524 171.939C56.5158 153.61 56.1764 152.27 42.0704 101.701C32.9756 69.0856 33.1905 64.1683 34.0842 58.9444C39.6836 26.4542 74.5 6.5 80 3.52564C76.5272 -4.48032 44.8305 1.93598 29.4237 14.8481H29.435Z",
    fill: "#5F9340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.435 14.8481C9.19786 31.8143 8.60963 61.7495 14.7973 80.3056C24.4011 109.116 28.3377 115.192 39.6836 153.69C45.4414 173.245 50.1585 190.075 45.0794 214.105C39.8307 238.975 30.0345 246.777 15.9737 275.679C4.28846 299.686 -3.27924 323.33 1.41522 350.221C2.81791 358.25 5.62327 383.768 25.4418 402.279C46.6405 422.072 71.1874 419.608 84.0039 432.157C96.8204 444.706 96.8543 479.66 85.9609 487.326C80.5651 491.13 74.1851 490.119 49.5816 487.076C35.7923 485.372 31.6182 490.301 29.616 493.753C26.8785 498.5 28.1567 505.961 32.2743 509.788C39.7175 516.693 53.1562 508.38 53.1222 508.005C53.043 506.915 51.9797 507.88 50.9051 507.824C44.5025 507.506 47.4323 512.571 39.1859 510.788C37.1384 510.345 32.8625 507.88 32.1272 502.293C31.6634 498.739 33.6996 492.788 37.6474 491.573C49.0952 488.064 68.269 494.185 74.6263 494.344C81.9904 494.525 84.8862 494.809 90.6893 490.778C100.338 484.066 102.114 468.894 101.979 457.777C101.854 447.715 102.307 427.728 81.2098 416.235C71.9453 411.193 51.2784 405.731 41.4709 396.373C37.0253 392.137 34.2652 391.013 23.8129 372.9C14.2882 356.399 16.0416 339.274 16.1208 330.155C16.2791 310.463 20.8039 296.177 29.2087 278.166C41.6066 251.626 46.7536 251.229 53.7444 233.013C63.7668 206.917 63.122 184.363 60.4524 171.939C56.5158 153.61 56.1764 152.27 42.0704 101.701C32.9756 69.0856 33.1905 64.1683 34.0842 58.9444C39.6836 26.4542 74.5 6.5 80 3.52564C76.5272 -4.48032 44.8305 1.93598 29.4237 14.8481H29.435Z",
    fill: "url(#paint0_linear_6187_11629)",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1843 153.542C62.4301 148.499 56.6012 156.611 56.6012 156.611C56.6012 156.611 54.4634 166.373 65.4028 170.986C76.3514 175.598 95.828 174.073 95.828 174.073C95.828 174.073 83.9293 158.586 73.1751 153.542L73.1843 153.542Z",
    fill: "#81C341"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6097 156.778L88.5078 171.009",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6097 156.778L88.5078 171.009",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0714 157.393L64.707 166.198",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6128 161.734L75.7341 160.835",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3075 165.131L80.6914 171.174",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0069 168.531L86.9023 168.271",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1843 153.542C62.4301 148.499 56.6012 156.611 56.6012 156.611C56.6012 156.611 54.4634 166.373 65.4028 170.986C76.3514 175.598 95.828 174.073 95.828 174.073C95.828 174.073 83.9293 158.586 73.1751 153.542L73.1843 153.542Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2823,
    cy: 504.391,
    rx: 2.28415,
    ry: 5.74167,
    transform: "rotate(-180 28.2823 504.391)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.083,
    cy: 538.4,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 34.083 538.4)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1887,
    cy: 519.85,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(-180 36.1887 519.85)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.97,
    cy: 503.949,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(-180 31.97 503.949)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8372,
    cy: 503.066,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(-180 35.8372 503.066)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1887,
    cy: 511.9,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(-180 36.1887 511.9)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.0951,
    cy: 509.692,
    rx: 2.98696,
    ry: 7.50833,
    transform: "rotate(-180 31.0951 509.692)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.5518,
    cy: 516.758,
    rx: 2.28415,
    ry: 5.74167,
    transform: "rotate(-180 33.5518 516.758)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2158,
    cy: 518.966,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 30.2158 518.966)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.3759,
    cy: 532.216,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 33.3759 532.216)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.8095,
    cy: 511.9,
    rx: 2.10844,
    ry: 7.06667,
    transform: "rotate(-180 28.8095 511.9)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.4852,
    cy: 533.099,
    rx: 1.75704,
    ry: 4.41667,
    transform: "rotate(-180 35.4852 533.099)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9736,
    cy: 542.817,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 31.9736 542.817)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7272,
    cy: 545.467,
    rx: 1.40563,
    ry: 3.53333,
    transform: "rotate(-180 33.7272 545.467)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4577,
    cy: 520.292,
    rx: 1.40563,
    ry: 4.85833,
    transform: "rotate(-180 28.4577 520.292)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8369,
    cy: 526.917,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 35.8369 526.917)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.3252,
    cy: 525.15,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 32.3252 525.15)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2158,
    cy: 527.8,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 30.2158 527.8)",
    fill: "#E8E06E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_if_6187_11629)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5673,
    cy: 535.75,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(-180 30.5673 535.75)",
    fill: "#E8E06E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_if_6187_11629",
    x: 24,
    y: 496.649,
    width: 8.56641,
    height: 17.4834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_if_6187_11629",
    x: 29.9727,
    y: 531.101,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_if_6187_11629",
    x: 31.3789,
    y: 510.783,
    width: 9.62109,
    height: 20.1338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_if_6187_11629",
    x: 27.1602,
    y: 494.882,
    width: 9.62109,
    height: 20.1338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_if_6187_11629",
    x: 31.0273,
    y: 493.999,
    width: 9.62109,
    height: 20.1338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_if_6187_11629",
    x: 31.3789,
    y: 502.833,
    width: 9.62109,
    height: 20.1338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_if_6187_11629",
    x: 26.1094,
    y: 500.184,
    width: 9.97266,
    height: 21.0166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_if_6187_11629",
    x: 29.2695,
    y: 509.017,
    width: 8.56641,
    height: 17.4834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_if_6187_11629",
    x: 26.1055,
    y: 511.666,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_if_6187_11629",
    x: 29.2656,
    y: 524.916,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_if_6187_11629",
    x: 24.6992,
    y: 502.833,
    width: 8.21875,
    height: 20.1338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_if_6187_11629",
    x: 31.7266,
    y: 526.683,
    width: 7.51562,
    height: 14.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_if_6187_11629",
    x: 27.8633,
    y: 535.518,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_if_6187_11629",
    x: 30.3203,
    y: 539.934,
    width: 6.8125,
    height: 13.0664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_if_6187_11629",
    x: 25.0508,
    y: 513.434,
    width: 6.8125,
    height: 15.7168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_if_6187_11629",
    x: 31.7266,
    y: 519.617,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_if_6187_11629",
    x: 28.2148,
    y: 517.851,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_if_6187_11629",
    x: 26.1055,
    y: 520.5,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_if_6187_11629",
    x: 26.457,
    y: 528.45,
    width: 8.21875,
    height: 16.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6187_11629"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6187_11629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6187_11629",
    x1: -230,
    y1: -52.4746,
    x2: -248.729,
    y2: -7.94017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#157E0B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6187_11629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 508,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6187_11629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 508,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangingVine);
export default __webpack_public_path__ + "static/media/hanging_vine.9911189f0d29854172fd1800ad3809a5.svg";
export { ForwardRef as ReactComponent };